import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

window.Echo = new Echo({
  broadcaster: "reverb",
  key: process.env.REACT_APP_REVERB_APP_KEY,
  wsHost: process.env.REACT_APP_REVERB_HOST,
  wsPort: process.env.REACT_APP_REVERB_PORT ?? 443,
  wssPort: process.env.REACT_APP_REVERB_PORT ?? 443,
  forceTLS: (process.env.REACT_APP_REVERB_SCHEME ?? "https") === "https",
  enabledTransports: ["ws", "wss"],
  disableStats: true,

  // Auth para canais privados/presence
  authEndpoint: `${process.env.REACT_APP_API_BASE_URL}/broadcasting/auth`,
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      Accept: "application/json",
    },
  },
});

// Eventos de debug
window.Echo.connector.pusher.connection.bind("connected", () => {
  console.log("✅ WebSocket CONECTADO!");
});

window.Echo.connector.pusher.connection.bind("error", (err) => {
  console.error("❌ Erro WebSocket:", err);
});

window.Echo.connector.pusher.connection.bind("disconnected", () => {
  console.warn("⚠️ WebSocket DESCONECTADO");
});

window.Echo.connector.pusher.connection.bind("state_change", (states) => {
  console.log("🔄 Estado WebSocket:", states.current);
});

export default window.Echo;
